import { HeaderEquipmentIcon } from '../header-equipment-icon';
import { FC } from 'react';
import cx from 'classnames';
import { CatHeading } from '@blocks-react/components/Heading';
import styles from './HeaderNoSelectedEquipment.module.scss';
import { CatTooltip } from '@blocks-react/components/Tooltip';

export type HeaderNoSelectedEquipmentProps = {
  label?: string;
  subLabel?: string;
  isMobile?: boolean;
  isFeatureFlag?: boolean;
};

export const NoSelectedEquipment: FC<HeaderNoSelectedEquipmentProps> = ({
  label = '',
  subLabel = '',
  isMobile = false,
  isFeatureFlag = false
}) => {
  const mobileClassnames = {
    'text-truncate': isMobile
  };
  const isMobileSearchClassnames = {
    'text-start': subLabel
  };

  return (
    <>
      <div className={cx({ 'ms-1': !isFeatureFlag })}>
        <HeaderEquipmentIcon isFeatureFlag={isFeatureFlag} />
      </div>
      <div className="overflow-hidden">
        <p
          className={cx(
            'm-0',
            styles['header-no-selected-equipment-text'],
            mobileClassnames,
            isMobileSearchClassnames
          )}
        >
          {label}
        </p>

        {!isFeatureFlag && subLabel && (
          <CatTooltip position="auto" className="d-flex">
            <CatHeading slot="trigger" variant="footnote" className="m-0">
              <span
                className={cx(
                  styles['label-no-equipmet-selected'],
                  'd-block text-truncate'
                )}
              >
                {subLabel}
              </span>
            </CatHeading>
            <CatHeading variant="body-sm">{subLabel}</CatHeading>
          </CatTooltip>
        )}
      </div>
    </>
  );
};
